/**
 * Shared constants and value mappings for client item history lists
 */

/**
 * Star rating value mapping for recommendation score columns
 */
export const STAR_RATING_VALUE_MAPPING = [
	{
		value: '-',
		color: { text: '#d1d5db' },
	},
	{
		value: '●',
		color: { text: '#6b7280' },
	},
	{
		value: '●●',
		color: { text: '#f59e0b' },
	},
	{
		value: '●●●',
		color: { text: '#f59e0b' },
	},
	{
		value: '●●●●',
		color: { text: '#22c55e' },
	},
	{
		value: '●●●●●',
		color: { text: '#22c55e' },
	},
] as const;

/**
 * Recommendation level value mapping for badges
 */
export const RECOMMENDATION_LEVEL_VALUE_MAPPING = [
	{
		color: { text: '#ffffff', bg: '#16a34a' },
		value: 'Strong',
		displayText: 'Strong',
	},
	{
		color: { text: '#ffffff', bg: '#d97706' },
		value: 'Good',
		displayText: 'Good',
	},
	{
		color: { text: '#ffffff', bg: '#6b7280' },
		value: 'Fair',
		displayText: 'Fair',
	},
] as const;
